<template>
  <v-card flat>
    <v-row class="ma-0 pa-0" align="center">
      <v-col cols="12" class="pa-0">
        <v-toolbar flat height="60" dark color="error">
          <v-btn fab x-small color="white" depressed @click="onClose()">
            <v-icon class="error--text">close</v-icon>
          </v-btn>
          <v-toolbar-title class="pl-2 subheading">
            <span class="title">{{ item.key }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="modified" rounded depressed small color="white" class="mr-1" @click="onRefresh()">
            <span class="error--text text-none">中止</span>
          </v-btn>
          <v-btn v-if="modified" dark rounded depressed small color="white" @click.native="updateDialog = true">
            <span class="error--text text-none">更新</span>
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-card-text>
      <v-sheet :style="contentsHeight">
        <v-row class="ma-0 pa-0" align="center">

          <v-col cols="12" class="pa-0 b-B">
            <v-toolbar flat color="transparent" height="40">
              <v-toolbar-title class="text-left subheading">
                <span class="title">認証情報</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center" style="height:40px">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="8" class="pa-0" align="start">
                <span>displayName</span>
              </v-col>
              <v-col cols="3" class="pa-0" align="end">
                <span v-if="account != null" class="font-weight-medium">{{ account.displayName }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center" style="height:40px">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="8" class="pa-0" align="start">
                <span>email</span>
              </v-col>
              <v-col cols="3" class="pa-0" align="end">
                <span v-if="account != null" class="font-weight-medium">{{ account.email }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center" style="height:40px">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="10" class="pa-0" align="start">
                <span>emailVerified</span>
              </v-col>
              <v-col cols="1" class="pa-0" align="end">
                <v-switch
                  v-if="account != null"
                  v-model="account.emailVerified"
                  color="primary"
                  hide-details
                  small
                  inset
                  class="my-2"
                  disabled
                ></v-switch>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center" style="height:40px">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="10" class="pa-0" align="start">
                <span>disabled</span>
              </v-col>
              <v-col cols="1" class="pa-0" align="end">
                <v-switch
                  v-if="account != null"
                  v-model="account.disabled"
                  color="primary"
                  hide-details
                  inset
                  class="my-2"
                  disabled
                ></v-switch>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center" style="height:40px">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="4" class="pa-0" align="start">
                <span>creationTime</span>
              </v-col>
              <v-col cols="7" class="pa-0" align="end">
                <span v-if="account != null" class="font-weight-medium">{{ new Date(account.metadata.creationTime) }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center" style="height:40px">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="4" class="pa-0" align="start">
                <span>lastSignInTime</span>
              </v-col>
              <v-col cols="7" class="pa-0" align="end">
                <span v-if="account != null" class="font-weight-medium">{{ new Date(account.metadata.lastSignInTime) }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center" style="height:40px">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="8" class="pa-0" align="start">
                <span>providerData</span>
              </v-col>
              <v-col v-if="account != null" cols="3" class="pa-0" align="end">
                <!-- <template v-for="(item, index) in account.providerData"> -->
                  <span class="font-weight-medium" v-for="(item, index) in account.providerData" :key="index">{{ '[' + item.providerId + '] ' }}</span>
                <!-- </template> -->
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0 b-B">
            <v-toolbar flat color="transparent" height="40">
              <v-toolbar-title class="text-left subheading">
                <span class="title">登録情報</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <span>registered</span>
              <v-switch
                v-model="tempUser.registered"
                color="error"
                hide-details
                inset
                class="mx-2"
                disabled
              ></v-switch>
            </v-toolbar>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="3" class="pa-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="6" class="pa-0">
                    <v-avatar size="80">
                      <v-img :src="getProfileImage()" rel="noreferrer" />
                    </v-avatar>
                  </v-col>
                  <v-col cols="6" class="pa-0">
                    <!-- <v-btn v-if="!checkAvatar() && mode != 'users'" dark rounded depressed x-small color="error" :disabled="type == 'view'" @click="onAvatarReset()">
                      <span class="px-1 text-none">初期化</span>
                    </v-btn> -->
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-text-field
                  id="email"
                  ref="email"
                  prepend-icon="email"
                  :append-icon="isGoogleAccount ? 'mdi-google' : ''"
                  name="login"
                  label="*Email"
                  v-model="tempUser.email"
                  type="email"
                  :rules="[rules.required, rules.email]"
                  readonly
                  disabled
                >
                </v-text-field>
              </v-col>
              <v-col cols="2" class="py-0" align="end">
                <vue-qrcode v-if="qr" :value="qr" :options="{ width: 100 }">></vue-qrcode>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="11" class="pa-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-text-field
                    ref="sei"
                    label="*姓（漢字）"
                    class="mr-1"
                    v-model="tempUser.sei"
                    :rules="[rules.required]"
                    :disabled="type == 'view'"
                    @change="modified = true"
                  ></v-text-field>
                  <v-text-field
                    ref="mei"
                    label="*名（漢字）"
                    class="mr-1"
                    v-model="tempUser.mei"
                    :rules="[rules.required]"
                    :disabled="type == 'view'"
                    @change="modified = true"
                  ></v-text-field>
                  <v-text-field
                    ref="seiY"
                    label="*姓（ふりがな）"
                    class="mr-1"
                    v-model="tempUser.seiY"
                    :rules="[rules.required]"
                    :disabled="type == 'view'"
                    @change="modified = true"
                  ></v-text-field>
                  <v-text-field
                    ref="meiY"
                    label="*名（ふりがな）"
                    class="mr-1"
                    v-model="tempUser.meiY"
                    :rules="[rules.required]"
                    :disabled="type == 'view'"
                    @change="modified = true"
                  ></v-text-field>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="11" class="pa-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="3" class="py-0">
                    <v-select
                      :items="$GENDERS"
                      label="性別"
                      v-model="tempUser.gender"
                      class="mr-1"
                      :disabled="type == 'view'"
                      item-value="key"
                      item-text="name"
                      small-chips
                      outlined
                      hideDetails
                      dense
                      @change="modified = true"
                    ></v-select>
                  </v-col>
                  <v-col cols="3" class="py-0">
                    <v-text-field
                      :label="'生年月日'"
                      v-model="tempUser.birth"
                      disabled
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="3" class="py-0">
                    <v-select
                      :items="schools"
                      label="所属塾"
                      v-model="school"
                      item-text="name"
                      item-value="key"
                      :disabled="type == 'view' || getPrivilegesLevel(data) >= 1"
                    ></v-select>
                  </v-col>
                  <v-col cols="3" class="py-0">
                    <v-select
                      :items="data.role == 'admin' ? $PRIVILEGES : $PRIVILEGES_OWNER"
                      label="役割"
                      v-model="tempUser.role"
                      item-text="name"
                      item-value="role"
                      small-chips
                      outlined
                      hideDetails
                      dense
                      :disabled="type == 'view' || getPrivilegesLevel(data) >= 2"
                      @change="modified = true"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0 b-B">
            <v-toolbar flat color="transparent" height="40">
              <v-toolbar-title class="text-left subheading">
                <span class="title">機能</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="8" class="pa-0">
                <span>画面</span>
              </v-col>
              <v-col cols="3" class="pa-0">
                <v-select
                  ref="month"
                  :items="theme"
                  label="テーマ"
                  v-model="tempUser.theme"
                  @change="modified = true"
                  hideDetails
                  item-text="name"
                  item-value="key"
                  :disabled="type == 'view'"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="9" class="pa-0">
                <span>伝言</span><span class="primary--text font-weight-bold">{{ tempUser.public ? ' 公開' : ' 非公開' }}</span>
              </v-col>
              <v-col cols="2" class="pa-0">
                <v-switch
                  v-model="tempUser.public"
                  color="primary"
                  :disabled="type == 'view'"
                  @change="modified = true"
                  hide-details
                  class="my-2"
                ></v-switch>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="getPrivilegesLevel(data) <= 1" cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="9" class="pa-0">
                <span>伝言（他塾）</span><span class="error--text font-weight-bold">{{ tempUser.chatsShare ? ' 公開' : ' 非公開' }}</span>
              </v-col>
              <v-col cols="2" class="pa-0">
                <v-switch
                  v-model="tempUser.chatsShare"
                  color="error"
                  :disabled="type == 'view'"
                  @change="modified = true"
                  hide-details
                  class="my-2"
                ></v-switch>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0"></v-col>
              <v-col cols="9" class="pa-0">
                <span>生徒連絡先</span><span class="error--text font-weight-bold">
                  {{ tempUser.accessContact ? ' 閲覧許可' : ' 閲覧禁止' }}
                </span>
              </v-col>
              <v-col cols="2" class="pa-0">
                <v-switch
                  v-model="tempUser.accessContact"
                  color="error"
                  :disabled="type == 'view'"
                  @change="modified = true"
                  hide-details
                  class="my-2"
                ></v-switch>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0" align="center">
                <v-icon>mdi-shield-account</v-icon>
              </v-col>
              <v-col cols="9" class="pa-0">
                <span>アカウント</span><span :class="tempUser.enable ? 'primary--text font-weight-bold' : 'error--text font-weight-bold'">{{ tempUser.enable ? ' 有効' : ' 無効' }}</span>
              </v-col>
              <v-col cols="2" class="pa-0">
                <v-switch
                  v-model="tempUser.enable"
                  :color="tempUser.enable ? 'primary' : 'error'"
                  @change="modified = true"
                  hide-details
                  class="my-2"
                  :disabled="type == 'view'"
                >
                </v-switch>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0" align="center">
                <v-icon>mdi-shield-account</v-icon>
              </v-col>
              <v-col cols="9" class="pa-0">
                <span>公開伝言グループ作成</span><span class="error--text font-weight-bold">{{ tempUser.public ? ' 可能' : ' 不可' }}</span>
              </v-col>
              <v-col cols="2" class="pa-0">
                <v-switch
                  v-model="tempUser.chatsCreate"
                  color="error"
                  @change="modified = true"
                  hide-details
                  class="my-2"
                  :disabled="type == 'view'"
                >
                </v-switch>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0" align="center">
                <v-icon>mdi-shield-account</v-icon>
              </v-col>
              <v-col cols="9" class="pa-0">
                <span>告知操作</span><span class="error--text font-weight-bold">{{ tempUser.public ? ' 可能' : ' 不可' }}</span>
              </v-col>
              <v-col cols="2" class="pa-0">
                <v-switch
                  v-model="tempUser.notice"
                  color="error"
                  @change="modified = true"
                  hide-details
                  class="my-2"
                  :disabled="type == 'view'"
                >
                </v-switch>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0" align="center">
                <v-icon>mdi-shield-account</v-icon>
              </v-col>
              <v-col cols="9" class="pa-0">
                <span>資料操作</span><span class="error--text font-weight-bold">{{ tempUser.docs ? ' 可能' : ' 不可' }}</span>
              </v-col>
              <v-col cols="2" class="pa-0">
                <v-switch
                  v-model="tempUser.docs"
                  color="error"
                  @change="modified = true"
                  hide-details
                  class="my-2"
                  :disabled="type == 'view'"
                >
                </v-switch>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0" align="center">
                <v-icon>mdi-shield-account</v-icon>
              </v-col>
              <v-col cols="9" class="pa-0">
                <span>特権モード</span>
              </v-col>
              <v-col cols="2" class="pa-0">
                <v-switch
                  v-model="tempUser.root"
                  color="error"
                  @change="modified = true"
                  hide-details
                  class="my-2"
                  :disabled="type == 'view'"
                >
                </v-switch>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0 b-B">
            <v-toolbar flat color="transparent" height="40">
              <v-toolbar-title class="text-left subheading">
                <span class="title">教室</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-col>

          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0" align="center"></v-col>
              <v-col cols="10" class="pa-0">
                <v-row class="ma-0 py-0" align="center">
                  <v-col cols="12" class="py-0 b-B-GREY-DARK" align="center">
                    <v-row align="center" justify="center" style="height:48px;">
                      <!-- <template v-for="(header, index) in headers"> -->
                        <v-col :cols="header.width"  :align="header.align" class="pa-0" v-for="(header, index) in headers" :key="header.key">
                          <v-sheet v-if="checkMode(header)" class="pa-0 customHeader" color="transparent">
                            <template v-if="header.valid">
                              <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                              <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                            </template>
                            <template v-else>
                              <span>{{ header.title }}</span>
                            </template>
                          </v-sheet>
                        </v-col>
                      <!-- </template> -->
                      <v-col class="pa-0" align="center">
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="pa-0" align="center">
                    <div>
                      <RecycleScroller
                        class="scroller"
                        :items="myGroups"
                        :item-size="44"
                        key-field="key"
                      >
                        <template v-slot="{ item, index }">
                          <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                            <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;">
                              <!-- <template v-for="(header) in headers"> -->
                                <v-col :cols="header.width" class="pa-0" align="start" v-for="(header) in headers" :key="header.key">
                                  <template v-if="header.key == 'primary'">
                                    <v-row class="ma-0 pa-0" align="center">
                                      <v-col cols="12" class="py-0" align="center">
                                        <v-btn icon disabled @click.stop="onGroupChange(item)" class="ma-0 pa-0">
                                          <v-icon v-if="groupCurrent != null && item.key == groupCurrent">mdi-radiobox-marked</v-icon>
                                          <v-icon v-else>mdi-radiobox-blank</v-icon>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </template>
                                  <template v-else-if="header.key == 'select'">
                                    <v-row class="ma-0 pa-0" align="center">
                                      <v-col cols="12" class="py-0 pl-6" align="center">
                                        <v-checkbox
                                          v-model="groupSelected[item.key]"
                                          color="primary"
                                          @change="onChangeSelected(item)"
                                          dense
                                          hide-details
                                          :disabled="type == 'view'"
                                          class="ma-0 pa-0"
                                        ></v-checkbox>
                                      </v-col>
                                    </v-row>
                                  </template>
                                  <template v-else-if="header.key == 'order'">
                                    <v-row class="ma-0 pa-0" align="center">
                                      <v-col cols="6" class="pa-0" align="center">
                                        <v-btn icon small disabled @click.stop.prevent="onOrderChange(index, -1)" class="ma-0 pa-0">
                                          <v-icon>mdi-chevron-up</v-icon>
                                        </v-btn>
                                      </v-col>
                                      <v-col cols="6" class="pa-0" align="center">
                                        <v-btn icon small disabled @click.stop.prevent="onOrderChange(index, 1)" class="ma-0 pa-0">
                                          <v-icon>mdi-chevron-down</v-icon>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </template>
                                  <template v-else-if="header.key == 'name'">
                                    <v-row class="ma-0 pa-0" align="center">
                                      <v-col cols="2" class="py-0" align="end">
                                        <v-avatar size="30">
                                          <img v-if="item.avatar" :src="item.avatar.thumbnail">
                                          <v-avatar v-else size="30" :color="item.color"><span class="font-weight-bold white--text" style="font-size:20px; user-select: none;">{{ getNamePrefixFromItem(item) }}</span></v-avatar>
                                        </v-avatar>
                                      </v-col>
                                      <v-col class="pa-0">
                                        <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                                      </v-col>
                                    </v-row>
                                  </template>
                                  <template v-else-if="header.key == 'classType'">
                                    <v-chip small :color="item.classroom ? 'primary' : 'success'"><span >{{ item[header.key] }}</span></v-chip>
                                  </template>
                                </v-col>
                              <!-- </template> -->
                            </v-row>
                          </v-sheet>
                        </template>
                      </RecycleScroller>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="1" class="pa-0" align="center"></v-col>
            </v-row>
          </v-col>

          <template v-if="$route.path != '/setting' && getPrivilegesLevel(data) == 0">
            <v-col cols="12" class="pa-0 b-B">
              <v-toolbar flat color="transparent" height="40">
                <v-toolbar-title class="text-left subheading">
                  <span class="title">塾設定</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0" align="center">
                  <v-icon>mdi-shield-account</v-icon>
                </v-col>
                <v-col cols="9" class="pa-0">
                  <span>多重ログイン</span>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-switch
                    v-model="tempUser.multi"
                    color="error"
                    @change="modified = true"
                    hide-details
                    class="my-2"
                    :disabled="type == 'view'"
                  >
                  </v-switch>
                </v-col>
              </v-row>
            </v-col>
            <v-col  v-if="tempUser.multi" cols="12" class="pa-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0" align="center"></v-col>
                <v-col cols="10" class="pa-0">
                  <v-row class="ma-0 py-0" align="center">
                    <v-col cols="12" class="py-0 b-B-GREY-DARK" align="center">
                      <v-row align="center" justify="center" style="height:48px;">
                        <!-- <template v-for="(header, index) in headersSchools"> -->
                          <v-col :cols="header.width"  :align="header.align" class="pa-0" v-for="(header, index) in headersSchools" :key="header.key">
                            <v-sheet class="pa-0 customHeader" color="transparent">
                              <template v-if="header.valid">
                                <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                                <v-icon :color="headersSchools[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                              </template>
                              <template v-else>
                                <span>{{ header.title }}</span>
                              </template>
                            </v-sheet>
                          </v-col>
                        <!-- </template> -->
                        <v-col class="pa-0" align="center">
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="pa-0" align="center">
                      <div>
                        <RecycleScroller
                          class="scroller"
                          :items="mySchools"
                          :item-size="44"
                          key-field="key"
                        >
                          <template v-slot="{ item }">
                            <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                              <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;">
                                <!-- <template v-for="(header) in headersSchools"> -->
                                  <v-col :cols="header.width" class="pa-0" align="start" v-for="(header) in headersSchools" :key="header.key">
                                    <template v-if="header.key == 'select'">
                                      <v-row class="ma-0 pa-0" align="center">
                                        <v-col cols="6" class="py-0" align="center">
                                          <v-checkbox
                                            v-model="schoolsSelected[item.key]"
                                            color="primary"
                                            @change="onSchoolChangeSelected(item)"
                                            dense
                                            hide-details
                                            disabled
                                            class="ma-0 pa-0"
                                          ></v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="py-0" align="center">
                                          <v-btn icon disabled @click.stop="onSchoolChange(item)">
                                            <v-icon v-if="item.key == schoolsCurrent">mdi-radiobox-marked</v-icon>
                                            <v-icon v-else>mdi-radiobox-blank</v-icon>
                                          </v-btn>
                                        </v-col>
                                      </v-row>
                                    </template>
                                    <template v-else-if="header.key == 'name'">
                                      <v-row class="ma-0 pa-0" align="center">
                                        <v-col cols="2" class="pa-0">
                                          <v-avatar size="30">
                                            <img v-if="item.avatar" :src="item.avatar.thumbnail">
                                            <v-avatar v-else size="30" :color="item.color"><span class="font-weight-bold white--text" style="font-size:20px; user-select: none;">{{ getNamePrefixFromItem(item) }}</span></v-avatar>
                                          </v-avatar>
                                        </v-col>
                                        <v-col class="pa-0">
                                          <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                                        </v-col>
                                      </v-row>
                                    </template>
                                    <template v-else-if="header.key == 'classType'">
                                      <v-chip small :color="item.classroom ? 'primary' : 'success'"><span >{{ item[header.key] }}</span></v-chip>
                                    </template>
                                  </v-col>
                                <!-- </template> -->
                              </v-row>
                            </v-sheet>
                          </template>
                        </RecycleScroller>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="1" class="pa-0" align="center"></v-col>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </v-sheet>
    </v-card-text>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='更新'
        message='更新します。よろしいですか？'
        :dialog='updateDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='Error'
        message='UID does not exist'
        :dialog='errorDialog'
        color="error"
        :cancel='false'>
      </app-basic-dialog>
    </div>

  </v-card>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import axios from 'axios'
import DatePicker from '../../components/common/TemplateDate.vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'

Vue.component('template-date-picker', DatePicker)
Vue.component('vue-qrcode', VueQrcode)

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      privilege: 'shared/privilege',
      windowSize: 'shared/windowSize'
    }),
    form () {
      return {
        sei: this.tempUser.sei,
        mei: this.tempUser.mei,
        seiY: this.tempUser.seiY,
        meiY: this.tempUser.meiY,
        email: this.tempUser.email
      }
    },
    myGroups () {
      var temp = []
      if (!this.order) {
        return temp
      }
      for (var i in this.order) {
        var index = this.groups.findIndex(group => group.key === this.order[i])
        if (index !== -1) {
          if (this.groups[index].enable && this.groups[index].classroom && this.tempUser.groups[this.order[i]]) {
            var payload = JSON.parse(JSON.stringify(this.groups[index]))
            payload.classType = payload.classroom ? '教室' : 'グループ'
            temp.push(payload)
          }
        }
      }
      if (this.mode === 'users') {
        index = this.schools.findIndex(s => s.key === this.school)
        if (index !== -1) {
          var keys = Object.keys(this.schools[index].groups)
          for (i in keys) {
            var g = temp.findIndex(t => t.key === keys[i])
            if (g === -1) {
              index = this.groups.findIndex(group => group.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  payload = JSON.parse(JSON.stringify(this.groups[index]))
                  payload.classType = payload.classroom ? '教室' : 'グループ'
                  temp.push(payload)
                }
              }
            }
          }
        }
      }
      return temp
    },
    isGoogleAccount () {
      if (this.tempUser.email) {
        var index = this.tempUser.email.indexOf('gmail.com')
        return (index !== -1)
      }
      return false
    },
    mySchools () {
      var temp = []
      for (var i in this.schools) {
        if (this.schools[i].enable) {
          if (this.getPrivilegesLevel(this.data) === 0) {
            temp.push(JSON.parse(JSON.stringify(this.schools[i])))
          } else if (typeof this.tempUser.schools[this.schools[i].key] !== 'undefined') {
            temp.push(JSON.parse(JSON.stringify(this.schools[i])))
          }
        }
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60) + 'px;'
    }
  },
  props: ['item', 'dialog', 'type', 'mode'],
  data () {
    return {
      updateDialog: false,
      errorDialog: false,
      modified: false,
      account: null,
      school: null,
      selected: null,
      groupSelected: {},
      groupCurrent: null,
      schoolsSelected: {},
      schoolsCurrent: null,
      order: [],
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      headers: [
        { valid: false, over: false, value: 0, title: '選択', key: 'select', width: '1', align: 'center', mode: 'users' },
        { valid: false, over: false, value: 0, title: '↑↓', key: 'order', width: '1', align: 'center', mode: 'profile' },
        { valid: false, over: false, value: 0, title: '優先', key: 'primary', width: '1', align: 'center', mode: '*' },
        { valid: false, over: false, value: 0, title: '名称', key: 'name', width: '7', align: 'center', mode: '*' }
      ],
      headersSchools: [
        { valid: false, over: false, value: 0, title: '種別', key: 'select', width: '2', align: 'center' },
        { valid: false, over: false, value: 0, title: '名称', key: 'name', width: '9', align: 'start' }
      ],
      edit: true,
      tempUser: null,
      file: null,
      menu3: false,
      loading: false,
      rules: {
        required: value => !!value || '必須',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        entry: value => {
          const pattern = /^[a-zA-Z0-9]{10}$/
          return pattern.test(value) || 'Invalid code.'
        }
      },
      theme: [
        { key: 1, name: 'ライト（常時）' },
        { key: 2, name: 'ダーク（常時）' },
        { key: 3, name: '自動' }
      ],
      qr: null
    }
  },
  watch: {
    users () {
      this.createGroup()
    },
    groups () {
      this.createGroup()
    },
    item () {
      this.initital()
    },
    file () {
      if (this.file !== null) {
        this.modified = true
      }
    },
    schoolsSelected () {
      var keys = Object.keys(this.schoolsSelected)
      for (var i in keys) {
        if (keys[i] === this.schoolsCurrent) {
          return
        }
      }
      this.schoolsCurrent = this.tempUser.primary
    },
    selected () {
      if (this.mode === 'profile') {
        for (var i in this.selected) {
          if (this.selected[i].key === this.groupCurrent) {
            return
          }
        }
        this.groupCurrent = null
      }
    }
  },
  created () {
    this.getAccounts()
    this.initital()
  },
  methods: {
    getAccounts () {
      var vm = this
      this.loading = true
      this.account = null
      var payload = { uid: this.item.key }
      var url = this.$FUNCTIONS_URL + '/user/get'
      firebase.auth().currentUser.getIdToken().then(function (token) {
        axios.post(url, payload, {
          headers: { 'Authorization': `Bearer ${token}` }
        }).then(function (response) {
          vm.account = response.data
          vm.loading = false
        }).catch(function (error) {
          if (error) {
            // console.log(error)
          }
          vm.loading = false
          vm.account = null
          vm.errorDialog = true
        })
      })
    },
    initital () {
      this.tempUser = JSON.parse(JSON.stringify(this.item))
      if (typeof this.tempUser.docs === 'undefined') {
        this.tempUser['docs'] = false
      }
      if (typeof this.tempUser.theme === 'undefined') {
        this.tempUser['theme'] = 1
      }
      if (typeof this.tempUser.chatsShare === 'undefined') {
        this.tempUser['chatsShare'] = false
        this.tempUser['chatsCreate'] = false
      }
      if (typeof this.tempUser.multi === 'undefined') {
        this.tempUser['multi'] = false
      }
      if (typeof this.tempUser.primary === 'undefined') {
        this.tempUser['primary'] = null
      }
      if (typeof this.tempUser.primaryGroup === 'undefined') {
        this.tempUser['primaryGroup'] = null
      }
      if (typeof this.tempUser.accessContact === 'undefined') {
        Vue.set(this.tempUser, 'accessContact', false)
        if (this.getPrivilegesLevel(this.tempUser) < 3) {
          Vue.set(this.tempUser, 'accessContact', true)
        }
      }
      this.order = []
      if (typeof this.tempUser.order === 'undefined') {
        var keys = Object.keys(this.tempUser.groups)
        for (var i in keys) {
          if (this.tempUser.groups[keys[i]]) {
            var index = this.groups.findIndex(g => g.key === keys[i])
            if (index !== -1 && this.groups[index].enable) {
              this.order.push(keys[i])
            }
          }
        }
      } else {
        for (i in this.tempUser.order) {
          index = this.groups.findIndex(g => g.key === this.tempUser.order[i])
          if (index !== -1 && this.groups[index].enable) {
            this.order.push(this.tempUser.order[i])
          }
        }
      }
      if (!this.tempUser.schools) {
        return
      }
      keys = Object.keys(this.tempUser.schools)
      for (i in keys) {
        if (this.tempUser.schools[keys[i]]) {
          this.school = keys[i]
          this.schoolsCurrent = keys[i]
          if (this.tempUser.primary === null) {
            this.tempUser['primary'] = this.school
          }
          break
        }
      }
      this.schoolsSelected = {}
      for (i in this.schools) {
        if (typeof this.tempUser.schools[this.schools[i].key] !== 'undefined') {
          this.schoolsSelected[this.schools[i].key] = true
        } else {
          this.schoolsSelected[this.schools[i].key] = false
        }
      }
      var sKeys = Object.keys(this.tempUser.schools)
      for (i in sKeys) {
        if (this.tempUser.schools[sKeys[i]]) {
          index = this.schools.findIndex(s => s.key === sKeys[i])
          if (index !== -1) {
            this.qr = location.protocol + '//' + location.host + '/' + '?&email=' + this.user.email + '&entry=' + this.schools[index].id
            break
          }
        }
      }
      this.createGroup()
    },
    createGroup () {
      this.groupSelected = {}
      for (var i in this.order) {
        this.groupSelected[this.order[i]] = true
      }
      for (i in this.groups) {
        if (this.groups[i].classroom && this.groups[i].enable) {
          if (typeof this.tempUser.groups[this.groups[i].key] !== 'undefined') {
            this.groupSelected[this.groups[i].key] = true
          } else {
            this.groupSelected[this.groups[i].key] = false
          }
        }
      }
      this.groupCurrent = this.tempUser.primaryGroup ? this.tempUser.primaryGroup : null

      this.selected = []
      if (!this.tempUser.groups) {
        return
      }
      var keys = Object.keys(this.tempUser.groups)
      for (i in keys) {
        if (this.tempUser.groups[keys[i]]) {
          var index = this.groups.findIndex(group => group.key === keys[i])
          if (index !== -1) {
            if (this.groups[index].classroom) {
              this.selected.push(JSON.parse(JSON.stringify(this.groups[index])))
            }
          }
        }
      }
    },
    checkMode (item) {
      if (item.mode === '*') {
        return true
      }
      return item.mode === this.mode
    },
    checkDisabled (item) {
      return item.key === this.tempUser.primary
    },
    checkAvatar () {
      if (this.tempUser.avatar) {
        return this.tempUser.avatar.path === this.user.photoURL
      }
      return true
    },
    getThemeName () {
      var index = this.theme.findIndex(t => t.key === this.tempUser.theme)
      if (index !== -1) {
        return this.theme[index].name
      }
      return ''
    },
    onClose () {
      this.$emit('dismissed')
    },
    isNotRemovable () {
      if (this.type === 'create') {
        return false
      }
      return this.isGoogleAccount
    },
    getNamePrefixFromItem (item) {
      var name = '？'
      if (item.name) {
        name = item.name.slice(0, 1)
      }
      return name
    },
    getProfileImage () {
      if (this.tempUser) {
        if (this.tempUser.avatar) {
          return this.tempUser.avatar.thumbnail
        }
      }
      return ''
    },
    getSchool () {
      for (var key in this.tempUser.schools) {
        if (this.tempUser.schools[key]) {
          var index = this.schools.findIndex(school => school.key === key)
          if (index !== -1) {
            return this.schools[index].name
          }
        }
      }
      return ''
    },
    getPrimarySchool () {
      if (typeof this.tempUser.primary !== 'undefined') {
        var index = this.schools.findIndex(s => s.key === this.tempUser.primary)
        if (index !== -1) {
          return this.schools[index].name
        }
      }
      return '-'
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    },
    onOrderChange (index, value) {
      var temp = index + value
      if (temp < 0) {
        temp = this.order.length - 1
      } else if (temp >= this.order.length) {
        temp = 0
      }
      var o = this.swap(this.order, index, temp)
      this.order = null
      this.order = o
      this.modified = true
    },
    onChangeSelected (item) {
      this.modified = true
      if (!this.groupSelected[item.key] && this.groupCurrent === item.key) {
        this.groupCurrent = null
      }
    },
    onGroupChange (item) {
      this.modified = true
      if (item.key === this.groupCurrent) {
        this.groupCurrent = null
      } else {
        for (var i in this.selected) {
          if (this.selected[i].key === item.key) {
            this.groupCurrent = item.key
          }
        }
      }
    },
    onSchoolChangeSelected (item) {
      var keys = Object.keys(this.schoolsSelected)
      this.modified = true
      for (var i in keys) {
        if (this.schoolsSelected[keys[i]] && keys[i] === this.schoolsCurrent) {
          return
        }
      }
      this.schoolsCurrent = this.tempUser.primary
    },
    onSchoolChange (item) {
      var keys = Object.keys(this.schoolsSelected)
      for (var i in keys) {
        if (this.schoolsSelected[keys[i]] && keys[i] === item.key) {
          this.schoolsCurrent = item.key
          this.modified = true
          return
        }
      }
    },
    onDismissed: function (result) {
      if (this.errorDialog) {
        this.errorDialog = false
        return
      }
      this.updateDialog = false
      if (result) {
        this.$nextTick(function () {
          this.onUpdate()
        })
      }
    },
    onUpdate () {
      var vm = this
      var current = this.data
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) {
          this.formHasErrors = true
        }
        this.$refs[f].validate(true)
      })
      if (this.formHasErrors) {
        return
      }
      this.loading = true
      var payload = JSON.parse(JSON.stringify(this.$store.getters['users/initial']))
      var keys = Object.keys(payload)
      for (var i in keys) {
        if (typeof this.tempUser[keys[i]] !== 'undefined') {
          payload[keys[i]] = JSON.parse(JSON.stringify(this.tempUser[keys[i]]))
        }
      }
      payload.registered = true
      if (this.getPrivilegesLevel(this.data) === 0) {
        var schools = {}
        if (this.tempUser.multi) {
          keys = Object.keys(this.schoolsSelected)
          for (i in keys) {
            if (this.schoolsSelected[keys[i]]) {
              schools[keys[i]] = false
            }
          }
          schools[this.schoolsCurrent] = true
        } else {
          schools[this.school] = true
        }
        payload.schools = schools
        if (this.school !== this.schoolsCurrent) {
          for (i in this.schools) {
            if (this.schools[i].key === this.schoolsCurrent) {
              localStorage.id = this.schools[i].id
              localStorage.school = this.schools[i].key
              break
            }
          }
        }
      }
      if (this.mode === 'users') {
        var group = {}
        keys = Object.keys(this.groupSelected)
        for (i in keys) {
          if (this.groupSelected[keys[i]]) {
            group[keys[i]] = true
            var x = this.order.indexOf(keys[i])
            if (x === -1) {
              this.order.push(keys[i])
            }
          } else {
            x = this.order.indexOf(keys[i])
            if (x !== -1) {
              this.order.splice(x, 1)
            }
          }
        }
        payload.groups = group
      }
      payload.order = this.order
      if (this.tempUser.primaryGroup !== this.groupCurrent) {
        payload.primaryGroup = this.groupCurrent
      }
      payload['updatedAt'] = parseInt(new Date().getTime())
      this.$store.dispatch('users/write', JSON.parse(JSON.stringify(payload))).then(() => {
        if (vm.file) {
          vm.$store.dispatch('storage/write', { blob: vm.file, child: 'users', id: vm.tempUser.key, uuid: this.genUUIDv4() }).then(() => {
            vm.loading = false
            vm.file = null
            vm.modified = false
            if (this.$route.path !== '/setting') {
              vm.$emit('dismissed')
            } else if (current.root !== payload.root) {
              vm.onLogout()
            }
          })
        } else {
          vm.loading = false
          vm.file = null
          vm.modified = false
          if (this.$route.path !== '/setting') {
            vm.$emit('dismissed')
          } else if (current.root !== payload.root) {
            vm.onLogout()
          }
        }
      })
    },
    onUpdated: function (value) {
      switch (value.id) {
        case 3:
          this.tempUser.birth = value.date
          this.modified = true
          break
      }
    },
    onAvatarReset () {
      this.modified = true
      this.file = null
      if (this.account !== null && this.account.photoURL) {
        this.tempUser.avatar = { path: this.account.photoURL, thumbnail: this.account.photoURL }
      } else {
        this.tempUser.avatar = null
      }
    },
    onRefresh () {
      this.file = null
      this.initital()
      this.modified = false
    },
    onLogout () {
      var vm = this
      vm.goto(vm, '/')
      this.$nextTick(function () {
        vm.gisSignOut()
        vm.$store.dispatch('auth/release').then(() => {
          vm.goto(vm, '/')
        })
      })
    }
  }
}
</script>

<style scoped>
.scroller {
  height: 100%;
}

.overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.customHeader {
  cursor: pointer;
  line-height: 48px;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}

</style>
